import { createCn } from 'cn/config'

/**
 * The type scale declared in globals.css @theme as --text-<name>. The class merger must know
 * these are font sizes: unconfigured, it reads `text-label` as a colour, so
 * `cn('text-label text-muted')` returned `text-muted` and every merged label silently fell
 * back to 16 px. test/cn.test.ts keeps this list in step with globals.css.
 */
export const TEXT_SIZES = [
  'title',
  'section',
  'heading',
  'body',
  'prose',
  'table',
  'dense',
  'label',
] as const

/** The only class merger in the app. Components import cn from here, never from 'cn'. */
export const cn = createCn({
  extend: { classGroups: { 'font-size': [{ text: [...TEXT_SIZES] }] } },
})
